/*tslint:disable*/

import {
    Component,
    forwardRef,
    OnInit,
    Input,
    AfterViewInit,
    Renderer,
    OnDestroy,
    Output,
    EventEmitter,
    NgModule
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzInputModule } from 'ng-zorro-antd';

declare var _;

const /** @type {?} */ noop = () => {
};

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UISelectBox),
    multi: true
};
export class UISelectBox implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {
/**
 * 用于注册数据处理回调函数
 */
dataHandler: Function;
/**
 * 用于注册数据处理回调函数
 */
labelHandler: Function;
/**
 * 显示值的标签
 */
label: any;

    
    valueType = '';

    
    level: any; //可控制选择的级别

    
    border;

    
    multiSelect: boolean = false;

    
    placeholder = '';

    
    width: any;

    
    height: any;

    
    onChange: EventEmitter<any> = new EventEmitter<any>();
/**
 * 控制选择框是否显示
 */
showBox: boolean;
/**
 * 选择框Tab数组
 */
selectBoxs: any[] = [];
/**
 * 当前激活的Tab
 */
activeIndex: number;


    focus: boolean = false;
    overFlag: boolean = false;

    dropdownFocus: boolean = false;

    documentClickListener: any;

    firstTimeInit: boolean = false;

    cacheLabels: any[] = [];
public onTouchedCallback: () => void = noop;
public onChangeCallback: (_: any) => void = noop;
public innerValue;
/**
 * @param {?} renderer
 */
constructor(public renderer: Renderer) {
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.firstTimeInit = true;
        this.showBox = false;
        this.selectBoxs = [];
        this.activeIndex = 0;
        this.dataHandler(this.selectBoxs, undefined, this.level >= 3 ? this.level : 3);
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.documentClickListener = this.renderer.listenGlobal('body', 'click', () => {
            this.hide();
        });
    }
/**
 * 隐藏弹窗
 * @return {?}
 */
hide() {
        this.showBox = false;
    }
/**
 * @param {?} event
 * @return {?}
 */
onInputFocus(event) {
        this.focus = true;
        event.stopPropagation();
        this.show()
    }
/**
 * @param {?} event
 * @return {?}
 */
onInputBlur(event) {
        this.focus = false;
        this.onTouchedCallback();
    }
/**
 * @param {?} event
 * @return {?}
 */
onMouseEnterHandler(event) {
        ////console.log('enter')
        this.dropdownFocus = true;
    }
/**
 * 输入框点击事件
 * @param {?} event
 * @return {?}
 */
inputClick(event) {
        event.stopPropagation();
    }
/**
 * 面板点击事件处理
 * @param {?} event
 * @return {?}
 */
panelClick(event) {
        event.stopPropagation();
    }
/**
 * 触发选择框弹出
 * @param {?} event
 * @return {?}
 */
toggle(event: Event): any {
        this.showBox = true;
    }
/**
 * @return {?}
 */
show() {
        if (!this.showBox && (this.focus || this.dropdownFocus)) {
            this.showBox = true;
        }
    }
/**
 * 选择某个选项时
 * @param {?} select
 * @param {?} i
 * @return {?}
 */
choose(select: any, i: number): any {

        if (!this.multiSelect) {

            this.selectBoxs[i].select = select;
            if (select.end || (this.level == select.level && select.level !== undefined)) {
                this.activeIndex = i;
                this.showBox = false;
            } else {
                this.activeIndex = i + 1;
                this.selectBoxs = this.selectBoxs.slice(0, i + 1);
                let /** @type {?} */ this_ = this;
                setTimeout(() => {
                    this_.dataHandler(this_.selectBoxs, select, this.level >= 3 ? this.level : 3);
                }, 10);
            }
            this.label = "";
            let /** @type {?} */ index = 0;
            for (let /** @type {?} */ selectBox of this.selectBoxs) {
                index++;
                if (selectBox.select) {
                    if (this.label.length != 0) {
                        this.label += "/";
                    }
                    this.label += selectBox.select.label;
                    if (index == this.selectBoxs.length) {
                        let /** @type {?} */ obj = {
                            value: select.value,
                            level: selectBox.select.level,
                            id: selectBox.select.id,
                            label: this.label
                        }
                        this.onChange.emit(obj)
                        this.value = this.valueType === 'object' ? obj : select.value;
                    }
                }
            }

        } else {
            //多选
            select.checked = !select.checked;
            if (select.checked) {
                if (!this.value) {
                    this.value = [];
                }
                this.value.push(select.value);
                this.cacheLabels.push(select.label);
                this.label = this.cacheLabels.join('、');

            } else {
                _.remove(this.value, n => {
                    return select.value === n;
                });
                _.remove(this.cacheLabels, n => {
                    return select.label === n;
                });
                this.label = this.cacheLabels.join('、');
            }
        }

    }
/**
 * @return {?}
 */
get value(): any {
        return this.innerValue;
    };
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            // 双向绑定获取对象
            if (this.valueType === "object") {
                const { value, label } = v;
                this.onChangeCallback({ value: value, label: label });
            } else if (this.valueType === "wholeName") {
                this.onChangeCallback(this.label);
            } else {
                this.onChangeCallback(v);
            }
        }
    }
/**
 * @return {?}
 */
blur() {
        this.onTouchedCallback();
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {

        if (value === null) {
            this.label = '';
            this.placeholder = '请输入'
        }
        if (value !== this.innerValue) {
            this.innerValue = value;
            if (this.labelHandler && this.innerValue && this.firstTimeInit) {
                this.labelHandler(this, this.innerValue);
                this.firstTimeInit = false;
            }
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * @return {?}
 */
clear() {
        this.label = '';
        this.value = '';
        this.innerValue = '';
        this.activeIndex = 0;
        if (this.multiSelect) {
            this.unCheckedAll();
            this.cacheLabels = [];
        }
    }
/**
 * @return {?}
 */
unCheckedAll() {
        if (this.selectBoxs[0] && this.selectBoxs[0]['data']) {
            for (let /** @type {?} */ d of this.selectBoxs[0]['data']) {
                d.checked = false;
            }
        }

    }
/**
 * @param {?} $event
 * @return {?}
 */
onMouseover($event) {
        this.overFlag = true;
        $event.stopPropagation();
    }
/**
 * @param {?} $event
 * @return {?}
 */
onMouseout($event) {
        this.overFlag = false;
        $event.stopPropagation();
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ui-select-box',
    template: `
    <div class="ui-select-div" (mouseleave)="onMouseout($event)">
        <input class="ant-input" [placeholder]="placeholder"
            [ngStyle]="{'width': width,'height':height,'border':border,'placeholder':placeholder}"  type="text"
            (mouseover)="onMouseover($event)"  [(ngModel)]="label" readonly (click)="inputClick($event)"
            (focus)="onInputFocus($event)" (blur)="onInputBlur($event)"/>
        <span
            role="close-icon"
            (click)="clear()"
            class="ant-select-selection__clear close-icon"
            style="-webkit-user-select: none;"
            *ngIf="label && overFlag">
        </span>
        <div class="select-box" [ngClass]="{hide:showBox!=true}" (blur)="blur()" (click)="panelClick($event)">
            <ul class="header">
                <li *ngFor="let selectBox of selectBoxs;let i = index" [ngClass]="{active:i==activeIndex}"
                    (click)="activeIndex=i">
                    {{selectBox.title}}
                </li>
            </ul>
            <button class="close" (click)="showBox=false">&times;</button>
            <ul class="body" *ngFor="let selectBox of selectBoxs;let i = index" [ngClass]="{hide:i!=activeIndex}"
                (mouseenter)="onMouseEnterHandler($event)">
                <li *ngFor="let select of selectBox.data">
                    <a href="javascript:void(0)" (click)="choose(select,i)" [ngClass]="{'selected':select.checked}">{{select.label}}</a>
                </li>
            </ul>
        </div>
    </div>`,
    styles: [`
        .ant-input{
            position: relative;
            display: inline-block;
            padding: 4px 7px;
            width: 100%;
            height: 28px;
            font-size: 12px;
            line-height: 1.5;
            color: rgba(0, 0, 0, 0.65);
            background-color: #fff;
            background-image: none;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            -webkit-transition: all .3s;
            transition: all .3s;
        }
        .ui-select-div{
            position: relative;
            display: inline;
            
        }
        .close-icon {
            opacity: 0;
            position: absolute;
            right: 5px;
            top: 50%;
        }
        .close-icon:hover {
            opacity: 1;
        }
        .ant-input:hover +.close-icon {
            opacity: 1;
        }
        .select-box{
            position: absolute;
            width: 395px;
            box-shadow: 2px 4px 12px rgb(123, 123, 123);
            z-index: 19999;
            background-color: #ffffff;
        }

        .hide {
            display: none;
        }

        ul.header {
            margin: 0;
            list-style: none;
            background-color: #108ee9;
            height: 32px;
            padding: 0 6px 0px;
            box-sizing: border-box;
            position: relative;
        }
        ul.header>li {
            padding: 0 8px 0 8px;
            margin-right: 12px;
            height: 100%;
            float: left;
            font-size: 12px;
            text-align: center;
            color: #fff;
            line-height: 30px;
            cursor: pointer;
        }
        ul.header>li.active {
            color: #108ee9;
            background-color: #fff;
        }

        ul.body>li {
            font-size: 12px;
            color: #333;
            float: left;
            text-align: left;
            width: 120px;
            margin-right: 11px;
        }

        ul.body>li>a {
            text-decoration: none;
            color: #333;
            display: inline-block;
            padding: 0px 12px;
            position: relative;
        }

        ul.body>li>a.active,ul.body>li>a:hover{
            background: #108ee9;
            color: #fff;
        }

        button.close {
            position: absolute;
            background-color: transparent;
            border: none;
            color: #ffffff;
            top: -4px;
            cursor:pointer;
            right: 5px;
            font-size: 20px;
        }
        @media screen and (max-width: 1024px) {
            input.select-input {
                width: 48px;
            }
        }

        .selected{
            background-color: #0d82de;
            color: #ffffff !important;
        }

    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dataHandler': [{ type: Input, args: ["data-handler", ] },],
'labelHandler': [{ type: Input, args: ["label-handler", ] },],
'label': [{ type: Input },],
'valueType': [{ type: Input },],
'level': [{ type: Input },],
'border': [{ type: Input },],
'multiSelect': [{ type: Input },],
'placeholder': [{ type: Input },],
'width': [{ type: Input },],
'height': [{ type: Input },],
'onChange': [{ type: Output },],
};
}

function UISelectBox_tsickle_Closure_declarations() {
/** @type {?} */
UISelectBox.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UISelectBox.ctorParameters;
/** @type {?} */
UISelectBox.propDecorators;
/**
 * 用于注册数据处理回调函数
 * @type {?}
 */
UISelectBox.prototype.dataHandler;
/**
 * 用于注册数据处理回调函数
 * @type {?}
 */
UISelectBox.prototype.labelHandler;
/**
 * 显示值的标签
 * @type {?}
 */
UISelectBox.prototype.label;
/** @type {?} */
UISelectBox.prototype.valueType;
/** @type {?} */
UISelectBox.prototype.level;
/** @type {?} */
UISelectBox.prototype.border;
/** @type {?} */
UISelectBox.prototype.multiSelect;
/** @type {?} */
UISelectBox.prototype.placeholder;
/** @type {?} */
UISelectBox.prototype.width;
/** @type {?} */
UISelectBox.prototype.height;
/** @type {?} */
UISelectBox.prototype.onChange;
/**
 * 控制选择框是否显示
 * @type {?}
 */
UISelectBox.prototype.showBox;
/**
 * 选择框Tab数组
 * @type {?}
 */
UISelectBox.prototype.selectBoxs;
/**
 * 当前激活的Tab
 * @type {?}
 */
UISelectBox.prototype.activeIndex;
/** @type {?} */
UISelectBox.prototype.focus;
/** @type {?} */
UISelectBox.prototype.overFlag;
/** @type {?} */
UISelectBox.prototype.dropdownFocus;
/** @type {?} */
UISelectBox.prototype.documentClickListener;
/** @type {?} */
UISelectBox.prototype.firstTimeInit;
/** @type {?} */
UISelectBox.prototype.cacheLabels;
/** @type {?} */
UISelectBox.prototype.onTouchedCallback;
/** @type {?} */
UISelectBox.prototype.onChangeCallback;
/** @type {?} */
UISelectBox.prototype.innerValue;
/** @type {?} */
UISelectBox.prototype.renderer;
}

export class UISelectBoxModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        UISelectBox
    ],
    exports: [UISelectBox],
    imports: [
        CommonModule,
        FormsModule
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function UISelectBoxModule_tsickle_Closure_declarations() {
/** @type {?} */
UISelectBoxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UISelectBoxModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
